import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      padding: 30,
      maxWidth: '85%',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '90%',
        padding: '30px 10px 100px 10px',
      },
    },
    formGroup: {
      marginTop: 10,
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      width: 'inherit',
      maxWidth: 250,
      marginLeft: 10,
      [theme.breakpoints.up('md')]: {
        top: '160px',
      },
      [theme.breakpoints.down('sm')]: {
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: 500,
        marginBottom: 15,
        marginLeft: 0,
      },
    },
    buttons: {
      minWidth: 210,
      margin: 5,
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        textTransform: 'none',
        minWidth: 300,
        margin: 3,
      },
    },
    buttonWrapper: {
      width: '100%',
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);

export const RadioStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

});
